import { render, staticRenderFns } from "./UserAssignRole.vue?vue&type=template&id=e271c040&scoped=true&"
import script from "./UserAssignRole.vue?vue&type=script&lang=js&"
export * from "./UserAssignRole.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignRole.vue?vue&type=style&index=0&id=e271c040&scoped=true&lang=css&"
import style1 from "./UserAssignRole.vue?vue&type=style&index=1&id=e271c040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e271c040",
  null
  
)

export default component.exports